// extracted by mini-css-extract-plugin
module.exports = {"jds-RichText":"RichText_jds-RichText__DUo0M","jds-RichText--resetSpacing":"RichText_jds-RichText--resetSpacing__uH81J"};